import React from 'react';

const ErrorNotice = ({ error, children, className }) => (
  <div className={`error-message-container ${className || ''}`}>
    {error && <div className="error-message">{error}</div>}
    {children}
  </div>
);

export default ErrorNotice;
